import { ReferralForm } from '@ltvco/refresh-lib/v1';
import { useEffect } from 'react';

export const Referrals = () => {
  useEffect(() => {
    document.title = 'Referrals - Bumper';
  }, []);

  return <ReferralForm />;
};
